export default "__VITE_ASSET__Cv7iQV6N__"